import { useAuth } from "@/contexts/AuthProvider";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import type { UserDetailsType } from "@/types/user";

const fetchUserDetails = async (token: string): Promise<UserDetailsType> => {
  const response = await axios.get(
    "https://kaman.rest/api/auth/customer-info",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const customer = response.data.data.customer;
  return {
    id: customer.id,
    name: customer.name,
    email: customer.email,
    phone: customer.phone,
    birthdate: customer.birthdate,
  };
};

export function useUserDetails() {
  const { token } = useAuth();

  return useQuery<UserDetailsType>({
    queryKey: ["userDetails", token],
    queryFn: () => fetchUserDetails(token as string),
    enabled: !!token,
  });
}
